import React from 'react';
import './TicketList.css';

import TicketCard from '../TicketCard/TicketCard';
import PostalEntry from '../PostalEntry/PostalEntry';
import SubscriptionEntry from '../SubscriptionEntry/SubscriptionEntry';
import ReactHtmlParse from 'html-react-parser';
import useTickets from '../../hooks/useTickets';
import { TitleText, SubtitleText } from 'raffle-house-uikit';
import DoublePrizeTicketCard from '../redesign/DoublePrizeTicketCard';
import NewPrizeCard from '../redesign/NewTicketCard';

const TicketList = (props) => {
  const {
    prizeId,
    raffles,
    isExpired,
    currentRaffle,
    title,
    subtitle,
    theme = 'light',
    reference,
    bonusDraw,
  } = props;
  const {
    type,
    loading,
    activeTicket,
    addToBasket,
    result,
    ticketsBundles,
  } = useTickets(prizeId);

  return (
    <div className='ticket-container' ref={reference}>
      {title || subtitle ? (
        <div className='ticket-text-container'>
          {Boolean(title) && (
            <TitleText
              isCentered
              as='h2'
              variant={'primary'}
              color={`${theme === 'light' ? 'color-1' : 'color-5'}`}
            >
              {title ? ReactHtmlParse(title) : null}
            </TitleText>
          )}
          {Boolean(subtitle) && (
            <SubtitleText
              isCentered
              color={`${theme === 'light' ? 'color-1' : 'color-5'}`}
            >
              {subtitle ? ReactHtmlParse(subtitle) : null}
            </SubtitleText>
          )}
        </div>
      ) : null}
      <div className='ticket-list'>
        <>
          {prizeId &&
            ticketsBundles?.map((ticket, index) => {
              let classNames = [];
              classNames.push('ts-page-only');
              let label = '';
              if (ticket === 25) {
                label = 'MOST POPULAR';
                classNames.push('most-popular');
              }
              if (ticket === 50) {
                label = 'LOWEST TICKET PRICE';
                classNames.push('lowest-price');
              }
              return (
                <NewPrizeCard
                  type={type}
                  key={index}
                  activeTicket={activeTicket}
                  ticket={ticket}
                  ticketsCount={ticket}
                  loading={loading}
                  onClick={addToBasket}
                  raffles={raffles}
                  isExpired={isExpired}
                  currentRaffle={currentRaffle}
                  theme={theme}
                  label={label}
                  result={result}
                  bonusDraw={bonusDraw}
                />
              );
            })}
          <PostalEntry loading={loading} theme={raffles.length > 1 ? 'light' : theme} />
        </>
      </div>
    </div>
  );
};

export default TicketList;
